<template>
  <div class="pinterest-wrapper">
    <LazyloadPlaceholder
      v-if="loading"
      class="pinterest__lazyload-placeholder"
    />
    <EmbedsPlaceholder
      v-if="errorLoad"
      class="pinterest__error"
      :link="`https://www.pinterest.com/pin/${vid}/`"
    />
    <div
      v-show="!errorLoad"
      ref="pinterest"
      class="pinterest"
    >
      <a
        :href="`https://www.pinterest.com/pin/${vid}/`"
        data-pin-terse="true"
        data-pin-do="embedPin"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import { addScriptIfNeeded } from '@devhacker/shared/utils/script/addScriptIfNeeded';
  import { removeScriptIfExists } from '@devhacker/shared/utils/script/removeScriptIfExists';
  import EmbedsPlaceholder from '~/components/EmbedsPlaceholder.vue';
  import LazyloadPlaceholder from '~/components/LazyloadPlaceholder.vue';
  import type { IPinterestEmbed } from '~/types/components/PinterestEmbed';

  export default defineNuxtComponent({
    name: 'PinterestEmbed',

    components: {
      EmbedsPlaceholder,
      LazyloadPlaceholder,
    },

    props: {
      elem: {
        type: Object as PropType<IPinterestEmbed>,
        required: true,
      },
    },

    data: () => ({
      url: 'https://assets.pinterest.com/js/pinit_main.js',
      errorLoad: false,
      loading: false,
    }),

    computed: {
      vid(): string {
        return this.elem.attributes.vid;
      },
    },

    mounted() {
      addScriptIfNeeded(
        this.url,
        () => {
          this.errorLoad = true;
          this.$emit('error');
          this.finishLoading();
        },
        this.finishLoading,
      );
      this.loading = true;
    },

    beforeUnmount() {
      removeScriptIfExists(this.url);
    },

    methods: {
      finishLoading() {
        this.loading = false;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .pinterest-wrapper {
    position: relative;
  }

  .pinterest {
    :deep() > * {
      display: block;
      margin: 0 auto;
    }

    position: relative;

    a {
      min-height: 160px;
    }

    &__lazyload-placeholder {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    &__error {
      display: flex;
      max-width: 592px;
      width: 100%;
      margin: 0 auto;
    }
  }
</style>
